<template>
  <div class="userMain">
    <div class="header">
      <div style="margin: 20px 0">
        <el-button-group>
          <PermissionsBtn
            :icon="'el-icon-download'"
            :btnType="'primary'"
            :permissionName="'_Export'"
            :downloadUrl="'/live/Anchor/downLoad'"
            :checkList="checkList"
          ></PermissionsBtn>
          <el-button
            style="margin-left: 10px"
            type="primary"
            icon="el-icon-plus"
            @click="openAddAnchor()"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
        </el-button-group>
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      class="table"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="账号" align="center">
        <template slot-scope="scope">
          {{ scope.row.userInfo && scope.row.userInfo.userCode }}
        </template>
      </el-table-column>

      <el-table-column label="用户名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.userInfo && scope.row.userInfo.nickName) }}
        </template>
      </el-table-column>

      <el-table-column label="电话号码" align="center">
        <template slot-scope="scope">
          <span>{{
            handledecrypt(
              scope.row.userInfo && scope.row.userInfo.mobile,
              scope.row.isShowAllPhone
            )
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="身份" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo && scope.row.userInfo.roleName }}</span>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.isOnline == 0 ? '离线' : '在线' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="deleteAnchor(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加表单对话框 -->
    <addAnchor ref="addAnchor" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getAllAnchors, removeAnchor } from '@/api/live.js';
import { getAllUsers } from '@/api/allUser.js';

const addAnchor = () => import('./components/addAnchor'); // 增加表单
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    addAnchor,
  },
  data() {
    return {
      list: null,
      path: '',
      userList: [],
      listLoading: false,
      checkList: [],
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    //this.fetchData()
    //this.getAllRoles()
    // this.getUser();
    this.anchorData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  inject: ['reload'],
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    async anchorData() {
      try {
        await getAllAnchors().then((res) => {
          this.list = res.data.listDatas;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    //获取正常用户列表
    async getUser() {
      try {
        await getAllUsers().then((res) => {
          this.userList = res.data;
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.anchorId;
      });
    },
    // 打开增加表单
    openAddAnchor() {
      this.$refs.addAnchor.dialogFormVisible = true;
      this.$refs.addAnchor.dialogTitle = '新增主播';
      // this.$refs.addAnchor.userList = this.userList;
    },
    onRefresh() {
      this.reload();
    },
    deleteAnchor(scope) {
      let checkIds = [];
      checkIds.push(scope.row.anchorId);
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0)
          return this.$message.error('请选择要删除的数据');
        this.$confirm('是否删除该主播', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await removeAnchor(checkIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  float: right;
}
.userMain {
  position: relative;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}
</style>
